class LoyaltyClick {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }
    onInit () {
        this._elem.addEventListener('click', e => {
            window.StampedFn.toggleRewardsModal()
        })
    }
}

export default LoyaltyClick



// WEBPACK FOOTER //
// ./src/resources/scripts/components/LoyaltyClick.js